<template>
  <b-navbar toggleable="md" type="dark" :sticky="true" v-show="$route.name !== 'login'">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item
          v-if="app.categories.length === 0 && app.loadingCount > 0"
          disabled
        >
          Loading bookmarks..
        </b-nav-item>
        <b-nav-item
          v-else
          v-for="category in app.categories"
          :key="category.id"
          :to="`/bookmarks/${category.id}#${encodeURI(category.title)}`"
        >
          {{ category.title }}
        </b-nav-item>

      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right class="manage-menu">
            <template slot="button-content">
              <em>Manage</em>
            </template>
            <b-dropdown-text class="text-nowrap">
              <span>
                <span v-if="app.checkingSession">Checking session..</span>
                <span v-else-if="app.account.id !== null">
                  Browsing as <b>{{ app.account.display_name }}</b>
                </span>
                <span v-else>
                  Browsing as <b>a guest</b>
                </span>
              </span>
            </b-dropdown-text>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item to="/login" v-if="!isLogged()">Login</b-dropdown-item>
            <b-dropdown-item to="/categories" v-if="isLogged()">Categories</b-dropdown-item>
            <b-dropdown-item to="/missing_pictures" v-if="isAdmin()">Missing Pictures</b-dropdown-item>
            <b-dropdown-item to="/users" v-if="isAdmin()">Users</b-dropdown-item>
            <b-dropdown-item to="/logout" v-if="isLogged()">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navigation',
  components: {},
  data() {
    return {
      account: this.$store.state.account,
      app: this.$store.state.app
    }
  }
};
</script>

<style lang="scss" scoped>
.manage-menu {
  display: block;
}
.manage-menu li {
  font-size: 13px;
}
@media (min-width: 1650px) {
  .manage-menu { display: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/Navigation.vue